import {
  createStyles,
  Title,
  Text,
  Space,
  Anchor,
  Image,
  Box,
  Divider,
} from '@mantine/core';
import { themeColors } from '../../config/themeSettings';

const DevdiscourseTraffickingBust = () => {
  const { classes } = useStyles();

  return (
    <div>
      <div className={classes.dateCategory}>
        November 06, 2025 | India News
      </div>
      <section className={classes.header}>
        <Title order={1} className={classes.title}>
          Delhi Police Busts Human Trafficking Operation in Paharganj with 'Say Help' App
        </Title>
      </section>
      <div className={classes.container}>
        <Box className={classes.sectionCenter}>
          <Image src="https://www.devdiscourse.com/remote.axd?https://devdiscourse.blob.core.windows.net/devnews/06_11_2025_20_46_14_7595066.jpg?width=920&format=webp" />
          <div className={classes.imageAttribution}>
            Image from Devdiscourse
          </div>

          <section className={classes.paragraph}>
            <Space h="md" />
            <Text>
              Delhi Police dismantled a human trafficking ring in Paharganj using the 'Say Help' app, leading to the arrest of two women. The app, designed for women's safety, facilitated police intervention. Evidence, including unused condoms and marked currency, was seized in the operation.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              The Operation
            </Title>
            <Space h="md" />
            <Text>
              In a significant operation, Delhi Police successfully disbanded a human trafficking network in the Paharganj area, thanks to an alert received via the 'Say Help' app. This intervention led to the arrest of two women associated with the racket. The breakthrough took place following a tip-off from the app, which is engineered to enhance women's safety and public security.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Say Help App's Role
            </Title>
            <Space h="md" />
            <Text>
              The 'Say Help' app played a crucial role as it empowered police actions against the human-trafficking offence, according to the Deputy Commissioner of Police in the Central District. The operation resulted in the discovery of three packets of unused condoms and Rs 2,000 in marked currency.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Investigation Details
            </Title>
            <Space h="md" />
            <Text>
              Deputy Commissioner of Police Nidhin Valsan detailed the operation, stating that the alert was received on the night of October 30. An expedited team comprising Special Staff from the Central District and the 'Say Help' team was mobilized to act on the intelligence.
            </Text>
            <Space h="md" />
            <Text>
              During the investigation, it was revealed that Galaxy Spa on DBG Road in Nabi Karim, Delhi, was implicated in these illicit activities. A covert police operation confirmed unlawful activities, leading to the arrest of several individuals. Legal proceedings were initiated under the Immoral Traffic Prevention Act of 1956.
            </Text>
            <Space h="md" />
            <Title order={4} className={classes.titleLeft}>
              Technology for Safety
            </Title>
            <Space h="md" />
            <Text>
              The 'Say Help' app, which offers real-time video, audio, and GPS tracking, continues to play a pivotal role in preventing gender violence and trafficking in high-risk areas.
            </Text>
            <Space h="md" />
          </section>
          <Divider></Divider>
          <Text className={classes.footNote}>
            Story by{' '}
            <Anchor href="https://www.devdiscourse.com/devdiscourse-stories" target="_blank">
              Devdiscourse News Desk
            </Anchor>
            . Source:{' '}
            <Anchor href="https://www.devdiscourse.com/article/headlines/3687655-delhi-police-busts-human-trafficking-operation-in-paharganj-with-say-help-app" target="_blank">
              Devdiscourse
            </Anchor>
          </Text>
        </Box>
      </div>
    </div>
  );
};

export default DevdiscourseTraffickingBust;

const useStyles = createStyles(theme => ({
  root: {
    fontFamily: 'Poppins',
    backgroundColor: themeColors.white,
    height: '100%',
    width: '100%',
    overflowX: 'hidden',
  },

  dateCategory: {
    fontSize: 14,
    fontWeight: 'normal',
    marginBottom: 10,
    textAlign: 'center',
    color: '#757575',
  },

  container: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
  },

  header: {
    textAlign: 'center',
    display: 'grid',
    gridTemplateColumns: 'minmax(min-content, 900px)',
    gridTemplateRows: 'auto',
    justifyContent: 'center',
    justifyItems: 'center',
    gap: 20,
  },

  footNote: {
    fontSize: 12,
    marginTop: 20,
    color: '#757575',
  },

  imageAttribution: {
    fontSize: 12,
    marginTop: 10,
    color: '#757575',
  },

  title: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: themeColors.anchor,
  },

  titleLeft: {
    fontFamily: 'Poppins',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  paragraph: {
    fontFamily: 'Poppins',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    color: themeColors.anchor,
  },

  sectionCenter: {
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '90vw',
    maxWidth: 900,
  },
}));
